
import * as __star__ from '@clayui/data-provider';

const {
default: __default__,
DataProvider,
FetchPolicy,
NetworkStatus,
useResource,
__esModule
} = __star__;

export {
DataProvider,
FetchPolicy,
NetworkStatus,
useResource,
__esModule
};
export default __default__;
